module.exports = __webpack_public_path__ + "img/msg_upload.0f7d1516.png";